import * as z from 'zod';

import { tcCategoryQueryLinkerSchema } from '@/_pages/settings/terms-categories/shared/schemas';
import { statusFormSchema } from '@/_schemas/status-input';

import { tcConditionQuerySchema } from './tc-condition-query-schema';

export const tcConditionFormSchema = tcConditionQuerySchema
  .omit({
    category_id: true,
  })
  .extend({
    title: z.string().min(3),
    term: z.string(),
    notes: z.string(),
    status: statusFormSchema,
    terms_condition_category: tcCategoryQueryLinkerSchema.nullable(),
  })
  .refine(({ terms_condition_category }) => terms_condition_category !== null, {
    message: 'Category is required',
    path: ['terms_condition_category'],
  });

export type TcConditionFormSchema = z.infer<typeof tcConditionFormSchema>;
